export enum BillingFeature
{
    form_builder = 'form_builder',
    site_grants = 'site_grants',
    site_documents = 'site_documents',
    pre_work_checks = 'pre_work_checks',
    maintenance_reminders = 'maintenance_reminders',
    app_earnings = 'app_earnings',
    sign_offs = 'sign_offs',
    client_portal = 'customer_portal',
    custom_reports = 'custom_reports',
    timesheets = 'timesheets',
}
